import { render } from "./Metrics.vue?vue&type=template&id=4b2acabc"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=4b2acabc&lang=css"
script.render = render

export default script